<template>
    <div>
        <div class="t-page" v-show="isSuccess == false">
            <div class="banner">
                <img src="https://resources.holowits.com.sg/HC/gitex2025-banner.png" alt="">
            </div>
            <el-form label-position="top" label-width="80px" :model="form" :rules="rules" ref="form">
                <div class="title first">
                    <!-- {{ international[language].title1 }} -->
                    Basic Information
                </div>
                <el-form-item label="Region" prop="area">
                    <el-select v-model="form.area" filterable style="width: 100%;">
                        <!-- <el-option label="Asia Pacific" value="亚太"></el-option> -->
                        <el-option label="Middle East" value="中东"></el-option>
                        <el-option label="Central Asia" value="中亚"></el-option>
                        <el-option label="North Africa" value="北非"></el-option>
                        <el-option label="South Africa" value="南非"></el-option>
                        <el-option label="Europe" value="欧洲"></el-option>
                        <el-option label="Latin America" value="拉美"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Country" prop="country">
                    <el-input v-model="form.country"/>
                </el-form-item>
                <el-form-item label="Customer Name" prop="companyName">
                    <el-input v-model="form.companyName"/>
                </el-form-item>
                <!-- <el-form-item label="Customer Industry" prop="industry">
                    <el-select v-model="form.industry" filterable style="width: 100%;">
                        <el-option label="Safe City" value="安平"></el-option>
                        <el-option label="Transportation" value="交通"></el-option>
                        <el-option label="Public Utilities" value="公共事业"></el-option>
                        <el-option label="Education" value="教育"></el-option>
                        <el-option label="Finance" value="金融"></el-option>
                        <el-option label="Healthcare" value="医疗"></el-option>
                        <el-option label="Electric Power" value="电力"></el-option>
                        <el-option label="Energy" value="能源"></el-option>
                        <el-option label="Manufacturing" value="制造"></el-option>
                        <el-option label="ISP" value="互联网服务提供商"></el-option>
                        <el-option label="SMEs" value="中小企业"></el-option>
                        <el-option label="Other" value="其他"></el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="Number of Customers" prop="numberOfPeople">
                    <el-input v-model="form.numberOfPeople"/>
                </el-form-item>
                <!-- <el-form-item label="陪同人员（姓名，工号）Accompanying Personnel (Name, Employee ID)" prop="accompanyingPerson">
                    <el-input type="textarea" v-model="form.accompanyingPerson"/>
                </el-form-item>
                <el-form-item label="提单人（姓名，工号）Submitter (Name, Employee ID)" prop="submiter">
                    <el-input type="textarea" v-model="form.submiter"/>
                </el-form-item> -->
                <el-form-item label="Email" prop="email">
                    <el-input v-model="form.email"></el-input>
                </el-form-item>
                <el-form-item label="Telephone" prop="telephone">
                    <el-input v-model="form.telephone"></el-input>
                </el-form-item>
                <!-- <el-form-item label="机会点描述 Opportunity Description">
                    <el-input v-model="form.opportunity"/>
                </el-form-item>
                <el-form-item label="交流重点 Key Discussion Points">
                    <el-input v-model="form.communication"/>
                </el-form-item> -->
            </el-form>

            <div class="t-input" style="display: flex; justify-content: center;">
                <el-button round style="background-color: #c7000b; color: #ffffff; width: 160px;" :loading="isLoading" @click="add">Submit</el-button>
            </div>
        </div>
        <div v-show="isSuccess === true" style="text-align: center;">
            <img src="https://resources.holowits.com.sg/HC/gitex_2025_yaoqinghan2.png" width="100%" alt="">
        </div>
    </div>
</template>
  
<script>
  import countrys from '@/utils/country.json';
  import {save} from '@/api/otherFormApi';
  export default {
    name: 'Gitex2025Index',
  data() {
      return {
          isSuccess: false,
          language: 'en',
          activity1: false,
          activity2: false,
          activity3: false,
          activity5: false,
          activity6: false,
          form: {
            area: '',
            country: '',
            companyName: '',
            numberOfPeople: '',
            email: '',
            telephone: '',
            source: ''
          },
          rules: {
            area: [{required: true, message: 'required', trigger: 'change'}],
            country: [{required: true, message: 'required', trigger: 'blur'}],
            companyName: [{required: true, message: 'required', trigger: 'blur'}],
            numberOfPeople: [{required: true, message: 'required', trigger: 'blur'}],
            email: [{required: true, message: 'required', trigger: 'blur'}],
            telephone: [{required: true, message: 'required', trigger: 'blur'}],
          },
          countryArr: [],
          isLoading: false,
          hasError: false
      }
  },
  created() {
      this.countryArr = countrys.country.map(item => {
          return {label: item, value: item}
      })
  },
  methods: {
    check(key, value) {
        if (key in this.rules) {
            return this.rules[key] = (value ? false : true);
        }
    },
     async add() {
        try {
            await this.$refs.form.validate()
            this.form['source'] = 'gitex-2025'
            this.isLoading = true
            const {data: {data, isSuccess}} = await save({
                content: JSON.stringify(this.form),
                pageSource: 'gitex-2025'
            })
            if (isSuccess) {
                this.isSuccess = true
                this.isLoading = false
            } else {
                this.isLoading = false
            }
        } catch(e) {
            this.isLoading = false
        }
        
    }
  }
  }
</script>
  
<style lang="less" scoped>
  .t-page {
    padding-bottom: 30px;
  }
  .banner {
      width: 100%;
      img {
          width: 100%;
      }
  }
  .error-info {
      color: red;
      font-size: 12px;
  }
  .company-icon {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
  
      .left {
          width: 163px;
          height: 80px;
      }
      .line {
          height: 40px;
          width: 2px;
          background-color: #000000;
      }
      .right {
          width: 105px;
          height: 105px;
      }
  }
  .first {
      margin-top: 20px;
  }
  
  .title {
      font-size: 18px;;
      font-weight: 600;
      margin-bottom: 20px;
  }
  .require {
    &::after {
        content: '*';
        padding-left: 2px;
        color: #c7000b;
    }
  }

  /deep/.el-form-item__label {
    font-size: 12px;
    color: #C0C4CC;
    font-weight: 500;
    display: inline-block;
    padding-bottom: 5px;
    line-height: 100%;
  }

  .t-input {
      margin-bottom: 20px;
      position: relative;

      .t-label {
          position: absolute;
          font-size: 14px;
          top: 10px;
          left: 16px;
          background-color: #ffffff;
          color: #C0C4CC;
          transition: all 0.4s;
  
          &::after {
              content: '*';
              padding-left: 2px;
              color: #c7000b;
          }
      }
      .optional {
          &::after {
              content: '';
          }
      }
      .focus {
          padding: 0 5px;
          top: -12px;
          font-size: 12px;
      }
    //   .focus2 {
    //       padding: 0 5px;
    //       top: -12px;
    //       left: 12px;
    //       font-size: 12px;
    //   }
      .el-input__inner:focus+.t-label {
          padding: 0 5px;
          top: -12px;
          font-size: 12px;
      }
  }
  .error {
    ::v-deep input {
        border-color: rgb(199, 0, 11) !important;
    }
    ::v-deep textarea {
        border-color: rgb(199, 0, 11) !important;
    }
  }
  @media only screen and (min-width: 992px) {
      .t-page {
          max-width: 838px;
          margin: 20px auto;
      }
  }
  @media only screen and (max-width: 991px) {
      .t-page {
          width: 100%;
          margin: 20px auto;
          padding: 15px;

          ::v-deep .h60 {
            .el-input__inner {
                height: 60px;
            }
          }
          .t-label {
            right: 25px;
          }
        //   .h60 + .t-label {
        //     top: 2px;
        //     bottom: 2px;
        //   }
        //   .t-label {
        //         position: absolute;
        //         font-size: 14px;
        //         top: 10px;
        //         left: 16px;
        //         background-color: #ffffff;
        //         color: #C0C4CC;
        //         transition: all 0.4s;
        
        //         &::after {
        //             content: '*';
        //             padding-left: 2px;
        //             color: #c7000b;
        //         }
        //     }
          .focus {
            padding: 0 5px;
            top: -10px;
            font-size: 8px;
          }
      }
  }
</style>